function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Search");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Search",
  transform: "translate(-1396.000000, -7829.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1396.000000, 7829.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "a_0293_search_100pt",
  transform: "translate(0.400000, 0.400000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M117.146903,108.279646 L81.6141593,72.7469027 C90.0234222,61.5866327 92.821717,47.1743077 89.19976,33.678058 C85.5778031,20.1818083 75.9395962,9.10703818 63.0725664,3.65663717 C43.0955433,-4.76141073 19.9544275,2.14147032 7.85379729,20.1281245 C-4.24683297,38.1147786 -1.92030171,62.1511731 13.4053097,77.4831858 C29.4646314,93.566196 54.9552075,95.26042 73.0017699,81.4442478 L108.513274,116.945133 C110.907393,119.330967 114.781279,119.32761 117.171258,116.93763 C119.561238,114.54765 119.564595,110.673764 117.178761,108.279646 L117.146903,108.279646 Z M45.4230088,78.5451618 C29.6274189,78.5659421 16.017948,67.4232378 12.9209771,51.9342137 C9.82400628,36.4451896 18.1025463,20.9260616 32.6917214,14.871554 C47.2808966,8.81704626 64.1152455,13.9143253 72.8953815,27.0448359 C81.6755176,40.1753464 79.9547428,57.6801027 68.7858407,68.8495575 C62.598237,75.0570015 54.187613,78.5359414 45.4230088,78.5132743 L45.4230088,78.5451618 Z",
  id: "Shape"
})))));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.94b912ee.svg";
export { ForwardRef as ReactComponent };